import { PlusCircleOutlined } from "@ant-design/icons";
import { Button, Col, Form, InputNumber, Row, Select } from "antd";
import { useEffect } from "react";
import { isMobile } from "react-device-detect";

interface PropsAddService {
  onAddService: any;
  existedServices: any[];
  services: any[];
  loading?: boolean;
}

export default function FormService({
  onAddService,
  existedServices,
  services,
  loading,
}: PropsAddService) {
  const [formService] = Form.useForm();

  const onFilterServices = (
    input: string,
    option?: { key: string; value: number; children: [] }
  ) =>
    (option?.children.join("") ?? "")
      .toLowerCase()
      .includes(input.toLowerCase());

  const onSubmit = () => {
    formService
      .validateFields()
      .then((values) => {
        let service = services.find((item) => item.id == values.id);

        onAddService({
          service_id: values.id,
          price: values.price,
          quantity: values.quantity,
        });

        formService.resetFields();
      })
      .catch(() => null);
  };

  // useEffect(() => {
  //   console.log('existedServices', existedServices)
  // },[existedServices]);

  return (
    <>
      <Form
        form={formService}
        name="form_service"
        layout="vertical"
        autoComplete="off"
      >
        <Row gutter={20}>
          <Col
            lg={{ span: 8 }}
            md={{ span: 8 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
          >
            <Form.Item
              label="Serviço"
              name="id"
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              <Select
                showSearch
                placeholder="Serviço"
                size="large"
                filterOption={onFilterServices}
                onChange={(value) => {
                  let _service = services.find((item) => item.value == value);

                  formService.setFieldValue("price", _service.price);
                }}
              >
                {services.map((service: any) => (
                  <Select.Option
                    key={service.value}
                    value={service.value}
                    disabled={existedServices.some(
                      (item: any) => item.service_id == service.value
                    )}
                  >
                    {service.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col
            lg={{ span: 3 }}
            md={{ span: 3 }}
            sm={{ span: 12 }}
            xs={{ span: 12 }}
          >
            <Form.Item
              label="Preço"
              name="price"
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              {}
              <InputNumber
                min={0.1}
                size="large"
                style={{ width: "100%" }}
                maxLength={5}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }
                onChange={(value) => {
                  formService.setFieldValue(
                    "total",
                    Number(value || 0) *
                      (formService.getFieldValue("quantity") || 0)
                  );
                }}
              />
            </Form.Item>
          </Col>

          <Col
            lg={{ span: 3 }}
            md={{ span: 3 }}
            sm={{ span: 12 }}
            xs={{ span: 12 }}
          >
            <Form.Item
              label="Quantidade"
              name="quantity"
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              <InputNumber
                min={1}
                size="large"
                style={{ width: "100%" }}
                maxLength={5}
                onChange={(value) => {
                  formService.setFieldValue(
                    "total",
                    Number(value || 0) *
                      (formService.getFieldValue("price") || 0)
                  );
                }}
              />
            </Form.Item>
          </Col>

          <Col
            lg={{ span: 3 }}
            md={{ span: 3 }}
            sm={{ span: 12 }}
            xs={{ span: 12 }}
          >
            <Form.Item label="Subotal" name="total">
              <InputNumber
                size="large"
                style={{ width: "100%" }}
                disabled={true}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }
              />
            </Form.Item>
          </Col>

          <Col
            lg={{ span: 3 }}
            md={{ span: 3 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
          >
            <Button
              type="primary"
              onClick={onSubmit}
              size="large"
              loading={loading}
              block={isMobile}
              style={isMobile ? {} : { marginTop: 30 }}
            >
              <PlusCircleOutlined />
              Adicionar serviço
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
}
